import { IEnvironment } from '../../app/core/interfaces/environment.interface';
export const environment: IEnvironment = {
  production: true,
  apiBaseURL: 'https://api.people.mindit.io',
  enableProfileManagement: false,
  enableProbation1MinDismiss: false
};
